import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { canUseDOM } from '@lib/canUseDOM';
import { getHistoryLength } from './utils';
export function withBackButton(Base) {
  return function () {
    if (!canUseDOM) {
      return /*#__PURE__*/React.createElement(Base);
    }
    var historyLength = getHistoryLength();
    var navigate = useNavigate();
    var location = useLocation();
    var isIndexFirst = location.pathname === '/' && historyLength === 1;
    var showBackButton = !isIndexFirst;
    Telegram.WebApp.BackButton[showBackButton ? 'show' : 'hide']();
    React.useEffect(function () {
      function onClick() {
        if (historyLength === 1) {
          if (window.history.length === 1) {
            navigate('/');
          } else {
            Telegram.WebApp.close();
          }
          return;
        }
        navigate(-1);
      }
      Telegram.WebApp.BackButton.onClick(onClick);
      return function () {
        Telegram.WebApp.BackButton.offClick(onClick);
      };
    }, [navigate, location]);
    return /*#__PURE__*/React.createElement(Base);
  };
}